import { UtilityService } from '@eforall/common';
import { FilterOperator, GridColumn, buildColumn } from '@eforall/dashboard';
import { SessionFeedback } from '../session-feedback-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<SessionFeedback, unknown>[] = [
		buildColumn(util, 'Id', row => row.accSessionSurveyResponseId, { header: 'accSessionSurveyResponseId' }),
		buildColumn(util, 'Id', row => row.accId, { header: 'accId' }),
		buildColumn(util, 'Text', row => row.accName, { header: 'accName', width: 30 }),
		buildColumn(util, 'Id', row => row.eventId, { header: 'eventId' }),
		buildColumn(util, 'Id', row => row.entrepreneurPersonId, { header: 'entrepreneurPersonId' }),
		buildColumn(util, 'FullName', row => row.entrepreneurName, { header: 'Entrepreneur', width: 60 }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.eventStartUTC), { header: 'Session Date', group: 'asc', hidden: true, width: 60 }),
		buildColumn(util, 'Text', row => row.programfacilitatorName, { header: 'Program Facilitator', width: 60 }),
		buildColumn(util, 'Number', row => row.accessibilityRating, { header: 'Accessibility Rating', headerTooltip: 'Accessibility: "I was able to easily attend this session (0..10)"', hidden: true }),
		buildColumn(util, 'Number', row => row.communicationRating, { header: 'Communication Rating', headerTooltip: 'Communication: "I received all the information I needed ahead of the session (0..10)"', hidden: true }),
		buildColumn(util, 'Number', row => row.organizationRating, { header: 'Organization Rating', headerTooltip: 'Organization: "The session was well facilitated by EforAll staff (0..10)"', hidden: true }),
		buildColumn(util, 'Text', row => row.feedback, { header: 'Feedback', filter: { operator: FilterOperator.IsNotNull } }),
	];


	return columns;

}